import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { withTranslation } from "react-i18next";
import fb from "../../assets/Facebook.svg";
import twitter from "../../assets/Twitter.svg";
import google from "../../assets/Google.svg";
import Button from "../../components/Button";
import InputField from "../../components/inputField";
import Page from "../../components/Page";
import phone from "../../assets/phone.svg";
import chat from "../../assets/chat.svg";
import email from "../../assets/email.svg";
import "./styles.css";
import { useForm } from "@mantine/form";

const Index = ({ t }) => {
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      company: "",
      zip: "",
      pass: "",
      rePass: "",
    },

    // functions will be used to validate values at corresponding key
    validate: {
      firstName: (value) =>
        value?.length < 1 ? "Please enter first name" : null,
      lastName: (value) =>
        value?.length < 1 ? "Please enter last name" : null,
      email: (value) => (/^\S+@\S+$/.test(value) ? null : "Invalid email"),
      company: (value) =>
        value?.length < 1 ? "Please enter company name" : null,
      zip: (value) => (value?.length < 1 ? "Please enter Zip code" : null),
      pass: (value) =>
        value?.length < 8 ? "Password must at least have 8 characters" : null,
      rePass: (value, values) =>
        value !== values?.pass ? "Passwords did not match" : null,
    },
  });
  return (
    <Page className="landing-page">
      <div className="contactmain">
        <div className="form">
          <h4 className="text-dark border-0 drop">
            <img src={email} width="22px" style={{ marginRight: "2px" }} />
            Drop us a line
          </h4>
          <div className="contact-form">
            <p className="em">
              Contact us at: <b>support@faces2hire.com</b>
            </p>
            <InputField
              placeholder="First Name"
              form={form}
              validateName="firstName"
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            />
            <InputField
              placeholder="Last Name"
              form={form}
              validateName="firstName"
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            />
            <InputField
              placeholder="Your Email"
              form={form}
              validateName="firstName"
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            />
            <InputField
              placeholder="Subject"
              form={form}
              validateName="firstName"
              style={{ border: "1px solid rgb(0,0,0,0.1)" }}
            />
            <textarea
              placeholder="Message"
              rows={4}
              style={{
                border: "1px solid rgb(0,0,0,0.1)",
                borderRadius: "10px",
                padding: "5px",
                outline: "none",
              }}
            />
            <div
              className="captcha"
              style={{
                transform: "scale(0.75)",
                transformOrigin: "10px 25px",
              }}
            >
              <ReCAPTCHA sitekey="Your client site key" />
            </div>
            <div className="bot-buttons">
              <Button title={"Clear"} fontWeight="700" type="submit" />
              <Button
                title={"Send"}
                primary={true}
                fontWeight="700"
                type="submit"
              />
            </div>
          </div>
        </div>
        <div className="loc-map">
          <div className="text-dark border-0 drop d-flex justify-content-between">
            <h4>
              <img src={phone} width="22px" /> Give us a call
            </h4>
            <h4>
              <img src={chat} style={{ marginRight: "2px" }} />
              Get social with us
            </h4>
          </div>
          <div className="contact-form">
            <div className="social">
              <p>
                We're available by phone: <br />
                Monday-Friday 9AM-5PM EST <br />
                (866) 500-7171
              </p>
              <p>
                Find us on: <br />
                <a href="https://www.facebook.com/faces2hire">
                  <img src={fb} width="20px" />
                </a>
                <a href="https://twitter.com/faces2hire">
                  <img src={twitter} width="20px" />
                </a>
                <img src={google} className="m-2  " width="20px" />
              </p>
            </div>
            <h2>MAP HEREE</h2>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default withTranslation()(Index);
